export default __webpack_public_path__ + "static/media/Burning Burden Teleport.b4922f56.PNG";